/* =============================================================================
   RESERVES — the "Reserve not met / Reserve met" pill and its ⓘ explainer (2026-10-26)
   =============================================================================
   Owner, 2026-10-26: "have reserve not met marked on items where reserve isnt met …
   with explainers and info bubbles next to reserves explaining what they are."

   window.MHVReserve
     .EXPLAIN                    the one paragraph every ⓘ shows (the hub card, the lot
                                 page, the NOW CLOSING bar and the RESERVES badge)
     .pillHtml(status, pid)      markup for a pill — status 'met' | 'not_met'
     .set(pid, status)           flip every pill for that lot ('met' / 'not_met' /
                                 true / false). null leaves it as it is.
     .passedText(reason)         'Passed — reserve not met' for a timed lot that closed
                                 under its reserve, else 'Passed'

   ⚠️ IT NEVER KNOWS A RESERVE AMOUNT. Every status comes from the server — the card's
   Liquid render (current bid vs reserve, amount never printed), /api/live-bids
   `reserveStatus`, the bid response's `reserve_status`, the timed payloads'
   `reserveMet` — all derived from the engine's reserve rule (lib/bid-logic
   reserveAdjustedCurrent), under which "met" means the leading maximum reached it.
   ⚠️ The pill's markup is ALSO rendered by Liquid (snippets/auction-hub-bid.liquid), so
   change the two together. The styles are mhv-reserve.css.
   ⚠️ The ⓘ is a real <button> with an aria-label; it opens on tap or Enter, closes on
   Escape, an outside tap, scroll or resize — a hover-only tooltip is unreachable on a
   phone, which is where most bidding happens. ON A DESKTOP IT ALSO OPENS ON HOVER
   (owner, 2026-10-26): only where the pointer can hover (`(hover: hover) and (pointer:
   fine)`), closing a beat after the pointer leaves both the ⓘ and the bubble; a click
   on a hover-opened bubble PINS it rather than toggling it shut under the cursor.
   The icon is the site's icon-info SVG, copied here as ICON (keep the two the same).
   ============================================================================= */
(function () {
  'use strict';
  if (window.MHVReserve) return;

  var EXPLAIN = 'This lot has a reserve — a confidential minimum the bidding must reach before it can sell. ' +
    'Until bidding reaches it, the lot shows “Reserve not met”; if it never does, the lot passes (doesn’t sell).';
  /* The rule the engine follows, for the RESERVES badge (the longer explainer). Same
     words as lib/bidding-facts RESERVE_EXPLAIN and the Bidder Terms ("Reserve Items"). */
  var RULE = 'Some lots have a reserve, a confidential minimum the bidding must reach before the lot can sell. ' +
    'Until it does, the lot shows “Reserve not met” and the current bid shows the leading maximum in full. ' +
    'Once a maximum passes the reserve, the current bid jumps to the reserve. A lot that never reaches its reserve passes (doesn’t sell).';

  function norm(status) {
    if (status === true || status === 'met') return 'met';
    if (status === false || status === 'not_met' || status === 'not-met') return 'not_met';
    return null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function label(st) { return st === 'met' ? 'Reserve met' : 'Reserve not met'; }
  /* snippets/icon-info.liquid — the same mark the hub's Auction Info and Bidding Quick Facts use. */
  var ICON = '<svg aria-hidden="true" focusable="false" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 7C14.5 10.866 11.366 14 7.5 14C3.63401 14 0.5 10.866 0.5 7C0.5 3.13401 3.63401 0 7.5 0C11.366 0 14.5 3.13401 14.5 7ZM7.5 13.1737C10.9096 13.1737 13.6737 10.4096 13.6737 7C13.6737 3.59035 10.9096 0.826284 7.5 0.826284C4.09035 0.826284 1.32628 3.59035 1.32628 7C1.32628 10.4096 4.09035 13.1737 7.5 13.1737Z" fill="currentColor"/>' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.19189 3.55353C8.19189 3.16326 7.91572 2.82899 7.50163 2.82899C7.09256 2.82899 6.80626 3.15786 6.80626 3.55353C6.80626 3.94642 7.09511 4.27259 7.50163 4.27259C7.9132 4.27259 8.19189 3.94104 8.19189 3.55353Z" fill="currentColor"/>' +
    '<path d="M6.97141 5.72371C6.97141 5.54117 7.11938 5.3932 7.30192 5.3932H7.69854C7.88107 5.3932 8.02905 5.54117 8.02905 5.72371V10.8467C8.02905 11.0292 7.88107 11.1772 7.69854 11.1772H7.30192C7.11938 11.1772 6.97141 11.0292 6.97141 10.8467V5.72371Z" fill="currentColor"/>' +
    '</svg>';

  function pillHtml(status, pid) {
    var st = norm(status) || 'not_met';
    return '<span class="mhv-reserve mhv-reserve--' + (st === 'met' ? 'met' : 'not-met') + '"' +
      (pid ? ' data-reserve-pid="' + esc(pid) + '"' : '') + ' data-reserve-state="' + st + '">' +
      '<span class="mhv-reserve__label">' + label(st) + '</span>' +
      '<button type="button" class="mhv-reserve__i" aria-label="What is a reserve?" aria-expanded="false">' + ICON + '</button>' +
      '</span>';
  }

  function paint(el, st) {
    el.setAttribute('data-reserve-state', st);
    el.classList.toggle('mhv-reserve--met', st === 'met');
    el.classList.toggle('mhv-reserve--not-met', st !== 'met');
    var l = el.querySelector('.mhv-reserve__label');
    if (l) l.textContent = label(st);
  }

  function set(pid, status) {
    var st = norm(status);
    if (!st || pid == null) return;
    var els = document.querySelectorAll('[data-reserve-pid="' + String(pid).replace(/[^0-9]/g, '') + '"]');
    for (var i = 0; i < els.length; i++) paint(els[i], st);
  }

  function passedText(reason) {
    return reason === 'reserve-not-met' ? 'Passed — reserve not met' : 'Passed';
  }

  // ── the info bubble — ONE element, moved to whichever ⓘ opened it ──────────
  var bubble = null;
  var openBtn = null;
  var openedByHover = false;
  var hoverTimer = null;
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  function ensureBubble() {
    if (bubble) return bubble;
    bubble = document.createElement('div');
    bubble.id = 'mhv-reserve-bubble';
    bubble.className = 'mhv-reserve-bubble';
    bubble.setAttribute('role', 'tooltip');
    bubble.hidden = true;
    document.body.appendChild(bubble);
    return bubble;
  }
  function close() {
    if (!bubble || bubble.hidden) return;
    bubble.hidden = true;
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.removeAttribute('aria-describedby'); }
    openBtn = null;
    openedByHover = false;
  }
  function place(btn) {
    var r = btn.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    var pad = 8;
    bubble.style.left = '0px'; bubble.style.top = '0px';
    var w = bubble.offsetWidth, h = bubble.offsetHeight;
    var left = Math.min(Math.max(pad, r.left + r.width / 2 - w / 2), Math.max(pad, vw - w - pad));
    // Below the ⓘ unless that runs off the bottom (the NOW CLOSING bar is at the bottom).
    var top = r.bottom + 8;
    var above = top + h > vh - pad && r.top - h - 8 > pad;
    if (above) top = r.top - h - 8;
    bubble.classList.toggle('mhv-reserve-bubble--above', above);
    bubble.style.left = Math.round(left) + 'px';
    bubble.style.top = Math.round(top) + 'px';
    bubble.style.setProperty('--arrow-x', Math.round(r.left + r.width / 2 - left) + 'px');
  }
  function open(btn, viaHover) {
    ensureBubble();
    if (openBtn === btn && !bubble.hidden) {
      if (viaHover) return;
      // A click on a bubble the hover opened PINS it; a second click closes it.
      if (openedByHover) { openedByHover = false; return; }
      close(); return;
    }
    close();
    var text = btn.getAttribute('data-reserve-text') === 'rule' ? RULE : EXPLAIN;
    bubble.textContent = text;
    // Inside the white NOW CLOSING bar the bubble keeps the light palette whatever the page theme.
    bubble.classList.toggle('mhv-reserve-bubble--light', !!btn.closest('.mhv-timed-bar'));
    bubble.hidden = false;
    openBtn = btn;
    btn.setAttribute('aria-expanded', 'true');
    btn.setAttribute('aria-describedby', 'mhv-reserve-bubble');
    openedByHover = !!viaHover;
    place(btn);
  }

  // Desktop hover: open on the ⓘ, stay open while the pointer is on it or on the bubble.
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var t = e.target;
      var btn = t && t.closest ? t.closest('.mhv-reserve__i') : null;
      var onBubble = bubble && t && bubble.contains(t);
      if (btn || onBubble) { clearTimeout(hoverTimer); hoverTimer = null; }
      if (btn) open(btn, true);
    });
    document.addEventListener('mouseout', function (e) {
      if (!openedByHover || !bubble || bubble.hidden) return;
      var to = e.relatedTarget;
      if (to && ((to.closest && to.closest('.mhv-reserve__i') === openBtn) || bubble.contains(to))) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { if (openedByHover) close(); }, 180);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.mhv-reserve__i') : null;
    if (btn) {
      // The ⓘ often sits inside a card link — it must not follow it.
      e.preventDefault();
      e.stopPropagation();
      open(btn);
      return;
    }
    if (bubble && !bubble.hidden && !(e.target && bubble.contains(e.target))) close();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && bubble && !bubble.hidden) {
      var b = openBtn;
      close();
      if (b && b.focus) b.focus();
    }
  });
  window.addEventListener('scroll', close, true);
  window.addEventListener('resize', close);

  window.MHVReserve = { EXPLAIN: EXPLAIN, RULE: RULE, pillHtml: pillHtml, set: set, passedText: passedText, open: open, close: close };
})();
